import { render, staticRenderFns } from "./StaticPrice.vue?vue&type=template&id=226e6fae&"
import script from "./StaticPrice.vue?vue&type=script&lang=js&"
export * from "./StaticPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports